import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Backoffice from '../backoffice';
import Design from '../design/DesignCondition';
import Geometry from '../geometry/Geometry';
import Home from '../home/Home';
import Info from '../info/Info';
import Scenario from '../scenario/Scenario';
import ErrorBoundary from './ErrorBoundary';
import NotFound from './NotFound';
import GeometryDetail from '../backoffice/geometry/GeometryDetail';
import EngineDetail from '../backoffice/engine/EngineDetail';
import HelpDetail from '../backoffice/help/HelpDetail';
import MaterialDetail from '../backoffice/material/MaterialDetail';
import ScenarioDetail from '../backoffice/scenario/ScenarioDetail';
import Layout from '../layout/Index';

export const route = {
    notFound: '*',
    home: '/',
    info: '/info',
    geometry: '/info/geometry',
    scenario: '/info/geometry/scenario',
    design: '/info/geometry/scenario/design/:projectId',

    backoffice: '/backoffice',
    backofficeGeometry: '/backoffice/geometry/:param',
    backofficeMaterial: '/backoffice/material/:param',
    backofficeScenario: '/backoffice/scenario/:param',
    backofficeEngine: '/backoffice/engine/:param',
    backofficeDocument: '/backoffice/document/newDocument',
};

const createRoute = (path: string, element: React.ReactNode) => ({
    path,
    element,
    errorElement: <ErrorBoundary />,
});

export default createBrowserRouter([
    {
        element: <Layout />,
        children: [
            createRoute(route.notFound, <NotFound />),
            createRoute(route.home, <Home />),
            createRoute(route.info, <Info />),
            createRoute(route.geometry, <Geometry />),
            createRoute(route.scenario, <Scenario />),
            createRoute(route.design, <Design />),
            createRoute(route.backoffice, <Backoffice />),
            createRoute(route.notFound, <NotFound />),
            createRoute(route.backofficeGeometry, <GeometryDetail />),
            createRoute(route.backofficeEngine, <EngineDetail />),
            createRoute(route.backofficeDocument, <HelpDetail />),
            createRoute(route.backofficeMaterial, <MaterialDetail />),
            createRoute(route.backofficeScenario, <ScenarioDetail />),
        ],
    },
]);

export const RouteProvider = RouterProvider;
